<div>
  <p-toast></p-toast>
  <router-outlet></router-outlet>
</div>
